// AGENDA requests
export const AGENDA_LIST = "AGENDA_LIST";
export const AGENDA_FULLLIST = "AGENDA_FULLLIST";
export const AGENDA_CREATE = "AGENDA_CREATE";
export const AGENDA_FILTER = "AGENDA_FILTER";
export const AGENDA_UPDATE = "AGENDA_UPDATE";
export const AGENDA_DELETE = "AGENDA_DELETE";
export const AGENDA_READ = "AGENDA_READ";

// AGENDA success
export const AGENDA_LIST_SUCCESS = "AGENDA_LIST_SUCCESS";
export const AGENDA_FULLLIST_SUCCESS = "AGENDA_FULLLIST_SUCCESS";
export const AGENDA_CREATE_SUCCESS = "AGENDA_CREATE_SUCCESS";
export const AGENDA_UPDATE_SUCCESS = "AGENDA_UPDATE_SUCCESS";
export const AGENDA_DELETE_SUCCESS = "AGENDA_DELETE_SUCCESS";
export const AGENDA_READ_SUCCESS = "AGENDA_READ_SUCCESS";

// AGENDA failed
export const AGENDA_REQUEST_FAILED = "AGENDA_REQUEST_FAILED";
